export class Token {
  constructor(
    public clientId: number | null = null,
    public tokenStr: string | null = null,
    public userId: number | null = null
  ) {
  }
}
